export const GET_STATS_DEFAULT_INTERVAL_MS = 5000;
